// extracted by mini-css-extract-plugin
module.exports = {"sectionMain":"style_sectionMain__acWoj"};